"use strict";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrders = void 0;
var tslib_1 = require("tslib");
var swr_1 = (0, tslib_1.__importDefault)(require("swr"));
var react_1 = require("react");
var __1 = require("..");
function useOrders(url, fetchOptions) {
    var _this = this;
    var key = '_id';
    var _a = (0, react_1.useState)(true), loading = _a[0], setIsLoading = _a[1];
    var loadingTimeout = function () {
        setIsLoading(false);
    };
    var fetch = (0, react_1.useCallback)(function (url) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
        var response;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, __1.http.get({ url: url })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    }); }, []);
    var _b = (0, swr_1.default)(url, fetch, (0, tslib_1.__assign)({}, fetchOptions)), data = _b.data, error = _b.error, isValidating = _b.isValidating, mutate = _b.mutate;
    var search = (0, react_1.useCallback)(function (search, shouldRevalidate) {
        if (shouldRevalidate === void 0) { shouldRevalidate = false; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var response, result;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __1.http.get({ url: url, params: search })];
                    case 1:
                        response = _a.sent();
                        result = response.data;
                        if (!(data && mutate)) return [3 /*break*/, 3];
                        return [4 /*yield*/, mutate(result, shouldRevalidate)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, result];
                }
            });
        });
    }, [url, data, mutate]);
    var create = (0, react_1.useCallback)(function (newObject, shouldRevalidate) {
        if (shouldRevalidate === void 0) { shouldRevalidate = false; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var response, result, newData;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __1.http.post({ url: url, data: newObject })];
                    case 1:
                        response = _a.sent();
                        result = response.data;
                        if (!(data && mutate)) return [3 /*break*/, 3];
                        newData = data;
                        if (Array.isArray(data)) {
                            newData = data.concat(result);
                        }
                        return [4 /*yield*/, mutate((0, tslib_1.__spreadArray)([], Array.from(new Set(newData)), true), shouldRevalidate)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, result];
                }
            });
        });
    }, [url, data, mutate]);
    var archive = (0, react_1.useCallback)(function (updatedObject, shouldRevalidate) {
        if (shouldRevalidate === void 0) { shouldRevalidate = false; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var currentObjectIndex, response, updatedObjects;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentObjectIndex = data.findIndex(function (object) { return object[key] === updatedObject[key]; });
                        return [4 /*yield*/, __1.http.patch({
                                url: "".concat(url, "/").concat(updatedObject[key], "/archive"),
                                data: updatedObject,
                            })];
                    case 1:
                        response = _a.sent();
                        if (!(data && mutate)) return [3 /*break*/, 3];
                        updatedObjects = (0, tslib_1.__spreadArray)([], data, true);
                        updatedObjects.splice(currentObjectIndex, 1, response.data);
                        return [4 /*yield*/, mutate(updatedObjects, shouldRevalidate)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, response.data];
                }
            });
        });
    }, [data, url, mutate, key]);
    var remove = (0, react_1.useCallback)(function (body, shouldRevalidate) {
        if (shouldRevalidate === void 0) { shouldRevalidate = false; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var response, result, updatedObjects, deletedIndex, updatedObjects;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __1.http.delete({ url: "".concat(url, "/").concat(body) })];
                    case 1:
                        response = _a.sent();
                        result = response.data;
                        if (!(data && mutate)) return [3 /*break*/, 5];
                        if (!Array.isArray(result)) return [3 /*break*/, 3];
                        updatedObjects = (0, tslib_1.__spreadArray)([], data, true).filter(function (current) {
                            var isDeleted = result.find(function (result) { return result[key] === current[key]; });
                            return !isDeleted;
                        });
                        return [4 /*yield*/, mutate(result.length === 0 ? [] : updatedObjects, shouldRevalidate)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        deletedIndex = data.findIndex(function (object) { return object[key] === result[key]; });
                        if (!(deletedIndex >= 0)) return [3 /*break*/, 5];
                        updatedObjects = (0, tslib_1.__spreadArray)([], data, true);
                        updatedObjects.splice(deletedIndex, 1);
                        return [4 /*yield*/, mutate(updatedObjects, shouldRevalidate)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/, result];
                }
            });
        });
    }, [url, data, mutate, key]);
    var update = (0, react_1.useCallback)(function (updatedObject, shouldRevalidate) {
        if (shouldRevalidate === void 0) { shouldRevalidate = false; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var currentObjectIndex, response, updatedObjects;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentObjectIndex = data.findIndex(function (object) { return object[key] === updatedObject[key]; });
                        return [4 /*yield*/, __1.http.patch({
                                url: "".concat(url, "/").concat(updatedObject[key]),
                                data: updatedObject,
                            })];
                    case 1:
                        response = _a.sent();
                        if (!(data && mutate)) return [3 /*break*/, 3];
                        updatedObjects = (0, tslib_1.__spreadArray)([], data, true);
                        updatedObjects.splice(currentObjectIndex, 1, response.data);
                        return [4 /*yield*/, mutate(updatedObjects, shouldRevalidate)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, response.data];
                }
            });
        });
    }, [data, url, mutate, key]);
    var addItem = (0, react_1.useCallback)(function (id, item, shouldRevalidate) {
        if (shouldRevalidate === void 0) { shouldRevalidate = false; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var currentObjectIndex, response, updatedObjects;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentObjectIndex = data.data.findIndex(function (object) { return object[key] === id; });
                        return [4 /*yield*/, __1.http.post({
                                url: "".concat(url, "/").concat(id, "/item"),
                                data: item,
                            })];
                    case 1:
                        response = _a.sent();
                        if (!(data && mutate)) return [3 /*break*/, 3];
                        updatedObjects = (0, tslib_1.__spreadArray)([], data.data, true);
                        updatedObjects[currentObjectIndex].items.push(item);
                        return [4 /*yield*/, mutate((0, tslib_1.__assign)((0, tslib_1.__assign)({}, data), { data: updatedObjects }), shouldRevalidate)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, response.data];
                }
            });
        });
    }, [data, url, mutate, key]);
    var addMessage = (0, react_1.useCallback)(function (id, index, message, shouldRevalidate) {
        if (shouldRevalidate === void 0) { shouldRevalidate = false; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var currentObjectIndex, response, updatedObjects;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentObjectIndex = data.data.findIndex(function (object) { return object[key] === id; });
                        return [4 /*yield*/, __1.http.post({
                                url: "".concat(url, "/").concat(id, "/item/").concat(index.toString(), "/message"),
                                data: message,
                            })];
                    case 1:
                        response = _a.sent();
                        if (!(data && mutate)) return [3 /*break*/, 3];
                        updatedObjects = (0, tslib_1.__spreadArray)([], data.data, true);
                        updatedObjects[currentObjectIndex].items[index].messages.push(message);
                        return [4 /*yield*/, mutate((0, tslib_1.__assign)((0, tslib_1.__assign)({}, data), { data: updatedObjects }), shouldRevalidate)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, response.data];
                }
            });
        });
    }, [data, url, mutate, key]);
    var addTracking = (0, react_1.useCallback)(function (id, index, tracking, shouldRevalidate) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
        var currentObjectIndex, response, updatedObjects;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentObjectIndex = data.data.findIndex(function (object) { return object[key] === id; });
                    return [4 /*yield*/, __1.http.post({
                            url: "".concat(url, "/").concat(id, "/item/").concat(index.toString(), "/tracking"),
                            data: tracking,
                        })];
                case 1:
                    response = _a.sent();
                    if (!(data && mutate)) return [3 /*break*/, 3];
                    updatedObjects = (0, tslib_1.__spreadArray)([], data.data, true);
                    updatedObjects[currentObjectIndex].item[index].trackingInformation.push(tracking);
                    return [4 /*yield*/, mutate((0, tslib_1.__assign)((0, tslib_1.__assign)({}, data), { data: updatedObjects }), shouldRevalidate)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, response.data];
            }
        });
    }); }, [data, url, mutate, key]);
    var addHistory = (0, react_1.useCallback)(function (id, history, shouldRevalidate) {
        if (shouldRevalidate === void 0) { shouldRevalidate = false; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var currentObjectIndex, response, updatedObjects;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentObjectIndex = data.data.findIndex(function (object) { return object[key] === id; });
                        return [4 /*yield*/, __1.http.post({
                                url: "".concat(url, "/").concat(id, "/history"),
                                data: history,
                            })];
                    case 1:
                        response = _a.sent();
                        if (!(data && mutate)) return [3 /*break*/, 3];
                        updatedObjects = (0, tslib_1.__spreadArray)([], data.data, true);
                        updatedObjects[currentObjectIndex].history.push(history);
                        return [4 /*yield*/, mutate((0, tslib_1.__assign)((0, tslib_1.__assign)({}, data), { data: updatedObjects }), shouldRevalidate)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, response.data];
                }
            });
        });
    }, [data, url, mutate, key]);
    var addPayment = (0, react_1.useCallback)(function (id, payment, shouldRevalidate) {
        if (shouldRevalidate === void 0) { shouldRevalidate = false; }
        return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var currentObjectIndex, response, updatedObjects;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentObjectIndex = data.data.findIndex(function (object) { return object[key] === id; });
                        return [4 /*yield*/, __1.http.post({
                                url: "".concat(url, "/").concat(id, "/payment"),
                                data: payment,
                            })];
                    case 1:
                        response = _a.sent();
                        if (!(data && mutate)) return [3 /*break*/, 3];
                        updatedObjects = (0, tslib_1.__spreadArray)([], data.data, true);
                        updatedObjects[currentObjectIndex].payments.push(payment);
                        return [4 /*yield*/, mutate((0, tslib_1.__assign)((0, tslib_1.__assign)({}, data), { data: updatedObjects }), shouldRevalidate)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, response.data];
                }
            });
        });
    }, [data, url, mutate, key]);
    (0, react_1.useEffect)(function () {
        if (isValidating) {
            setIsLoading(true);
            return;
        }
        setTimeout(loadingTimeout, 500);
    }, [isValidating]);
    var memoizedData = (0, react_1.useMemo)(function () { return (data && data.length !== 0 ? data : []); }, [data]);
    return {
        create: create,
        remove: remove,
        fetch: {
            data: memoizedData,
            error: error,
            loading: loading,
            mutate: mutate,
        },
        archive: archive,
        update: update,
        search: search,
        addMessage: addMessage,
        addTracking: addTracking,
        addItem: addItem,
        addHistory: addHistory,
        addPayment: addPayment,
    };
}
exports.useOrders = useOrders;
